export class Kind {
  geburtsDatum: Date;
  erhaltKindergeld: boolean;

  constructor(kind?: Kind) {
    this.geburtsDatum = kind && kind.geburtsDatum ? new Date(kind.geburtsDatum) : null;
    this.erhaltKindergeld = kind ? kind.erhaltKindergeld : false;
  }
}
